module.exports = __webpack_public_path__ + "img/tommrow.60b86842.svg";